import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-doughnut-chart',
  standalone: false,
  templateUrl: './doughnut-chart.component.html',
  styleUrl: './doughnut-chart.component.scss'
})
export class DoughnutChartComponent implements OnInit, AfterViewInit {
 
  @Input() dataset: {
    backgrounds: [],
    data: [],
    labels: [],
  };

  chartData = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: ['#198038', '#24a148', '#f1c21b', '#ff832b', '#fa4d56', '#da1e28'],
        hoverOffset: 1,
      },
    ],
  };

  options = {
    plugins: {
      legend: {
        position: 'right',
        display: true,
        labels: {
          font: {
            size: 16,
            family: 'Cairo, sans-serif',
          },
        },
      },
    },
  };

  ngOnInit(): void {}
  
  ngAfterViewInit(): void {
    this.initChart();
  }

  initChart() {
    if (!this.dataset?.data && !this.dataset?.labels) return;

    var chart = this.chartData.datasets[0];
    chart.data = this.dataset.data;
    this.chartData.labels = this.dataset.labels;

    if (this.dataset.backgrounds?.length > 0) {
      chart.backgroundColor = [];
      chart.backgroundColor = this.dataset.backgrounds;
    }
  }
}
